import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { getBookingDetailOfRetrieveBookingAction } from "../RetrieveBooking/GetBookingDetailOfRetrieveBookingAction";


export class RetrieveCacheBookingAction extends BaseAction<IDefaultActionResult, boolean> {

    override async run(): Promise<IDefaultActionResult | null> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {            
            const alreadyCashData = localStorage.getItem("retrieveBookingCacheData")
            if (alreadyCashData) {
                const rbObject = JSON.parse(alreadyCashData)
                if (rbObject?.retrieveBooking) {
                    await getBookingDetailOfRetrieveBookingAction.execute()
                }
            } else {
                /**
                    * @page bookings can be alow accessible for guest user.
                    * So user will not find any booking.
                    * Means need to start a retrieve booking flow
                    */
                updateRecoilState("showRetrieveBookingAtom", true);
            }
            actionResult.status = "success"
        } catch (error) {

        } finally {
            return actionResult
        }
    }
}

export const retrieveCacheBookingAction = new RetrieveCacheBookingAction(); 